import { render, staticRenderFns } from "./AgentBottomBar.vue?vue&type=template&id=a8ebc316&scoped=true"
import script from "./AgentBottomBar.vue?vue&type=script&lang=ts"
export * from "./AgentBottomBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ebc316",
  null
  
)

export default component.exports